import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

interface CategoryGridProps {
  startIndex: number;
  count: number;
  title: string;
}

export default function CategoryGrid({ startIndex, count, title }: CategoryGridProps) {
  const { t } = useTranslation();
  const displayCategories = categories.slice(startIndex, startIndex + count);

  return (
    <div className="mb-16">
      <div className="flex items-center gap-4 mb-8">
        <span className="inline-block border border-accent-400 text-accent-400 text-xs font-semibold uppercase tracking-wider px-4 py-1.5 rounded-full">
          {t('categories.label')}
        </span>
        <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
          {title}
        </h3>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {displayCategories.map((cat) => (
          <a
            key={cat.id}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group block bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all hover:scale-[1.02]"
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">{cat.name}</h4>
              <p className="text-xs text-foreground-500 group-hover:text-primary-500 transition-colors">
                {t('categories.goto')}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}